import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { observer } from 'mobx-react-lite'
import { Fragment } from 'react/jsx-runtime'

import { CloseCircleCreate } from 'features/close-circle-create'
import { CloseCircleEdit } from 'features/close-circle-edit'

import citizenshipStore from 'shared/store/citizenship-store'
import { EmptyPage } from 'shared/ui/empty-page'
import { Loader } from 'shared/ui/loader'

const CloseCircleForm = observer(() => {
  const { id } = useParams()
  const { t } = useTranslation()

  useEffect(() => {
    void citizenshipStore.ensureAviaCitizenships()
  }, [])

  const hasCitizenshipsLoadError =
    citizenshipStore.citizenshipAvia === null &&
    citizenshipStore.aviaStatus === 'error'
  const isCitizenshipsInitialLoading =
    citizenshipStore.citizenshipAvia === null && !hasCitizenshipsLoadError

  if (hasCitizenshipsLoadError) {
    return (
      <EmptyPage
        title={t('error')}
        subTitle={t('error_des')}
        buttonText={t('try_again')}
        onClick={() => void citizenshipStore.ensureAviaCitizenships()}
      />
    )
  }

  if (isCitizenshipsInitialLoading) {
    return <Loader marginTop={150} />
  }

  return <Fragment>{id ? <CloseCircleEdit /> : <CloseCircleCreate />}</Fragment>
})

export default CloseCircleForm
